import { render, staticRenderFns } from "./PostServicesAditional.vue?vue&type=template&id=28563c2e"
import script from "./PostServicesAditional.vue?vue&type=script&lang=js"
export * from "./PostServicesAditional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports